import { Text, Stack, Link } from '@hotjar/hotsauce';
import { useTranslationWithPrefix } from '@hotjar/translations';
import styled from '@emotion/styled';
import { CreditCardInfo } from '~/subscription-management/components';
import type { Customer } from '~/subscription-management/api/common/model/customer';
import { PayPalInfo } from '~/subscription-management/components/paypal-info/PayPalInfo';

interface Props {
  paymentMethod: Customer['paymentMethod'];
  onEdit?: () => void;
  className?: string;
}

const S = {
  Link: styled(Link)`
    align-self: flex-start;
  `,
};

export function PaymentInfoCard({ paymentMethod, onEdit, className }: Props): JSX.Element | null {
  const { t } = useTranslationWithPrefix('checkout:wizard.review-order.payment-details');

  return (
    <Stack spacing="x1" direction="column" className={className}>
      <Text textType="subtitle2">{t('title')}</Text>
      {paymentMethod.paymentMethodType === 'CREDIT_CARD' && (
        <CreditCardInfo creditCardDetails={paymentMethod.details} />
      )}

      {paymentMethod.paymentMethodType === 'PAYPAL' && (
        <PayPalInfo paymentDetails={paymentMethod.details} withLogo />
      )}
      {onEdit && (
        <S.Link as="button" kind="standalone" onClick={onEdit}>
          {t('edit')}
        </S.Link>
      )}
    </Stack>
  );
}
